import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ConfirmDeleteComponent } from 'src/features/service-order/services-os-actions/ui/nota-credito-proveedor/confirm-delete/confirm-delete.component';
import { NotaCreditoProveedorComponent } from 'src/features/service-order/services-os-actions/ui/nota-credito-proveedor/nota-credito-proveedor.component';
import { OrderConfirmDialogComponent } from 'src/features/service-order/services-os-actions/ui/services-os-actions/order-confirm-dialog.component';
import { OrderFreezeDeadlineDialogComponent } from 'src/features/service-order/services-os-actions/ui/services-os-actions/order-freeze-deadline-dialog.component';
import { OrderRecalcHistoryDialogComponent } from 'src/features/service-order/services-os-actions/ui/services-os-actions/order-recalc-history-dialog.component';
import { ServicesOsActionsComponent } from 'src/features/service-order/services-os-actions/ui/services-os-actions/services-os-actions.component';
import { UploadFilesComponent } from 'src/features/service-order/services-os-actions/ui/upload-files/upload-files.component';
import { OrderPdfModule } from 'src/features/service-order/order-pdf/order-pdf.module';
import { PurchaseNotePdfButtonComponent } from 'src/features/purchase-note/purchase-note-pdf/ui/purchase-note-pdf-button/purchase-note-pdf-button.component';
import { DialogDeleteNpComponent } from 'src/features/purchase-note/delete-purchase-note/ui/dialog-delete-np/dialog-delete-np.component';

@NgModule({
  declarations: [
    ServicesOsActionsComponent,
    OrderRecalcHistoryDialogComponent,
    OrderFreezeDeadlineDialogComponent,
    OrderConfirmDialogComponent,
    NotaCreditoProveedorComponent,
    UploadFilesComponent,
    ConfirmDeleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TablerIconsModule,
    OrderPdfModule,
    PurchaseNotePdfButtonComponent,
    DialogDeleteNpComponent
  ],
  exports: [ServicesOsActionsComponent]
})
export class ServiceOrderActionsModule {}
